import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Gameaccessdata = () => {
  const [gameaccessdata, setGameaccessdata] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`gameAccessData?page=${page}`);
      setGameaccessdata(data.data);
      setLastPage(data.meta.last_page);
    })();
  }, [page]);
  const del = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      await axios.delete(`gameaccessdata/${id}`);
      setGameaccessdata(
        gameaccessdata.filter((gameaccessdata) => gameaccessdata.id !== id),
      );
    }
  };
  return (
    <Wrapper pageTitle={"Gameaccessdata"}>
      <InnerNav
        createLink={"/gameaccessdataCreate"}
        listLink={"/gameaccessdata"}
      />
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref </th>
                <th className="px-4 py-3">Msisdn </th>
                <th className="px-4 py-3">Game Id </th>
                <th className="px-4 py-3">Click Id </th>
                <th className="px-4 py-3">Client Id </th>
                <th className="px-4 py-3">Request Id </th>
                <th className="px-4 py-3">Mfilter Id </th>
                <th className="px-4 py-3">Message </th>
                <th className="px-4 py-3">Error Message </th>
                <th className="px-4 py-3">Source Ip </th>
                <th className="px-4 py-3">User Agent </th>
                <th className="px-4 py-3">Updated At </th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {gameaccessdata.map((gameaccessdata) => {
                return (
                  <tr
                    key={gameaccessdata.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-5">{gameaccessdata.id}</td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.msisdn}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.game_id}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.click_id}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.client_id}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.request_id}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.mfilter_id}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.message}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.error_message}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.source_ip}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.user_agent}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {gameaccessdata.UpdatedAt}
                    </td>
                    <td className="flex px-4 py-3 text-sm">
                      <Link
                        className="btn btn-sm btn-outline-secondary px-5"
                        to={`/gameaccessdata/${gameaccessdata.id}/edit`}
                      >
                        <AiFillEdit />{" "}
                      </Link>
                      <span
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => del(gameaccessdata.id)}
                      >
                        {" "}
                        <AiFillDelete className="text-rose-500 text-lg" />
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default Gameaccessdata;
